import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApplicationSettings } from "lib-config";
import { Observable, ReplaySubject } from "rxjs";
import { ApplicationRoleTemplate } from "../models/access-management/application-role-template.model";
import { ApplicationRole } from "../models/access-management/application-role.model";
import { CompanyRole } from "../models/access-management/company-role.model";

@Injectable({
    providedIn: "root"
})
export class RoleService {

    
    private _applicationRoles: ReplaySubject<ApplicationRole[]>;
    private _companyRoles: ReplaySubject<CompanyRole[]>;

    constructor(private http: HttpClient, private settings: ApplicationSettings) {
    }

    getApplicationRoles(): Observable<ApplicationRole[]> {
        this.initializeRoles();
        return this._applicationRoles.asObservable();
    }
    
    getCompanyRoles(): Observable<CompanyRole[]> {
        this.initializeRoles();
        return this._companyRoles.asObservable();
    }

    initializeRoles() {
        if(!this._applicationRoles)  {
            this._applicationRoles = new ReplaySubject<ApplicationRole[]>();
            this._companyRoles = new ReplaySubject<ApplicationRole[]>();
            let params: HttpParams = new HttpParams();
            params = params.set('ApplicationTemplateId', this.settings.policyServiceAppId.toString()); 
            this.http.get<ApplicationRoleTemplate>(`${this.settings.backendUrlPolicyService}/manage/application/template/structure`, {params: params}).subscribe(x => {

                var applicationRoles: ApplicationRole[];
                var companyRoles: CompanyRole[];
        
                if(!x) {
                    applicationRoles = null;
                    companyRoles = null;
                }
                else {
                    applicationRoles = x.roles.map(y => new ApplicationRole(y.id, y.name)); 
                    companyRoles = x.policies.find(y => y.name === "Company")?.roles.map(y => new CompanyRole(y.id, y.name)); 
                }
        
                this._applicationRoles.next(applicationRoles);
                this._applicationRoles.complete();

                this._companyRoles.next(companyRoles);
                this._companyRoles.complete();

            });
        } 
    }
}